import React from "react";
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

// ["error","info","success","warning"]

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

export default function FeedbackSnackbar(props) {
    const {open, message, handleClose, severity} = props
    // const [openNotification, setOpenNotification] = React.useState(open);
    // const [accessMessage, setAccessMessage] = React.useState("")

    // const handleClose = (event, reason) => {
    //     if (reason === 'clickaway') {
    //       return;
    //     }
    
    //     setOpenNotification(false)
    //   };

    const action = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClose}>
            Cerrar
          </Button>
        </React.Fragment>
      );

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            open={open}
            autoHideDuration={1500}
            onClose={handleClose}
            message={message}
            action={action}
        >
            <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                {/* This is a success message! */}
                {message}
            </Alert>
        </Snackbar>
    )
}